import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../../utils/decorators";


@Options({
    template: require("../templates/made-no-buttons.njk"),
})
export default class MadeNoButtons extends Marionette.View<Backbone.Model>{

}



// WEBPACK FOOTER //
// ./@modules/button-logic/views/made-no-buttons.ts